<dx-popup class="popup" [width]="650" [height]="200" [showTitle]="true" title="{{'ALGEMEEN.KIES_TAAL' | translate}}"
    [dragEnabled]="false" [hideOnOutsideClick]="false" [(visible)]="popupVisible" [showCloseButton]="false">
    <div *dxTemplate="let data of 'content'">
        <div class="alert alert-danger" role="alert" *ngIf="errorMessages">
            <ul>
                <li *ngFor="let error of errorMessages">
                    {{ error }}
                </li>
            </ul>
        </div>
        <div>
            <h5>{{'ALGEMEEN.KIES_TAAL' | translate}}</h5>
            <dx-radio-group [items]="languages" displayExpr="name" valueExpr="id" [(value)]="selectedLanguage"
                (onValueChanged)="onValueChanged($event)" layout="horizontal">
                <div *dxTemplate="let language of 'item'">
                    <div>{{ language.name }}</div>
                </div>
            </dx-radio-group>
            <br />
            <div>
                <dx-button text="{{'ALGEMEEN.ANNULEREN' | translate}}" type="warning" [useSubmitBehavior]="false"
                    (click)="hide()"></dx-button>&nbsp;&nbsp;
                <dx-button text="{{ 'ALGEMEEN.OPSLAAN' | translate}}" type="success" [useSubmitBehavior]="false"
                    (click)="onFormSubmit()"></dx-button>
            </div>
        </div>
    </div>
</dx-popup>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadingVisible" [showIndicator]="true"
    [showPane]="true" [shading]="true" [hideOnOutsideClick]="false">
</dx-load-panel>